import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IBusinessSFilter } from 'src/@types/SearchFilterTypes';
import { useStores } from 'src/models';

import { Page } from '../../../../components/Page';

import { BusinessGrid } from './BusinessGrid';
import SearchForm from './SearchForm';

/** * ## Business 설명
 * 컨텐츠 중 진행하는 사업에 대한 정보를 관리하는 화면
 */

export const Business = observer(() => {
  const { categoryStore } = useStores();
  // 검색 조건
  const [searchData, setSearchData] = useState<Partial<IBusinessSFilter>>({});
  // 목록 검색
  const onSearch = (data: IBusinessSFilter) => {
    setSearchData(data);
  };

  useEffect(() => {
    // 카테고리 조회
    const getCategory = async () => {
      await categoryStore.getCategory();
    };

    getCategory();
  }, []);

  return (
    <Page>
      <SearchForm onSearch={onSearch} />
      <BusinessGrid searchData={searchData} />
    </Page>
  );
});
export default Business;
